import Head from "next/head";
import Image from "next/image";
import Link from "next/link";
import { useRouter } from "next/router";
import Container from "../../../components/blogs/Container";
import { useEffect, useState } from "react";
import axios from "axios";
import { API_ENDPOINT } from "../../../utilities/constant";
import { parseISO, format } from "date-fns";

export default function Post() {
    const [post, setPost] = useState({})
    const [nextPost, setNextPost] = useState(null)
    const [previousPost, setPreviousPost] = useState(null)
    const router = useRouter()


    useEffect(() => {
        if (router.isReady) {
          getPostBySlug(router.query?.slug);
        }
    }, [router.isReady, router.query?.slug]);

    const getPostBySlug = async(slug) => {
        try {
            const response = await axios.get(`${API_ENDPOINT}/blogs/${slug}`, {});
            setPost(response.data);
            setNextPost(response.data.next_slug)
            setPreviousPost(response.data.previous_slug)
          } catch (error) {
            console.error("Error fetching blogs:", error);
            router.push("/blogs")
          }
    };
  
    return (
      <>
        <Head>
          <title>{post?.title ? `${post.title} | SERP Insights` : 'Blog Post | SERP Insights'}</title>
          <meta 
            name="description" 
            content={post?.excerpt || "Read our latest insights on SEO, digital marketing, and content strategy."} 
          />
        </Head>

        <Container className="!pt-0">
          <div className="mx-auto max-w-screen-md ">
            {/* Title h1 element removed as requested */}
  
            <div className="mt-8 flex justify-center space-x-3 text-gray-500 ">
              <div className="flex items-center gap-3">
                <div className="relative h-10 w-10 flex-shrink-0">
                      <Image
                        src={"/images/secondary logo.png"}
                        alt={post?.author}
                        className="rounded-full object-cover"
                        // fill
                        width={500} // Set appropriate width and height
                        height={300}
                        sizes="40px"
                      />
                 
                </div>
                <div>
                  <p className="text-gray-800 dark:text-gray-400">
                      {post?.author}
                  </p>
                  <div className="flex items-center space-x-2 text-sm">
                    {post?.created_at && <time
                      className="text-gray-500 dark:text-gray-400"
                      dateTime={post?.created_at}>
                      {format(
                        parseISO(post?.created_at),
                        "MMMM dd, yyyy"
                      )}
                    </time>}
                    <span>· {post?.estReadingTime || "5"} min read</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Container>
  
        { post?.main_image && <div className="relative z-0 mx-auto aspect-video max-w-screen-lg overflow-hidden lg:rounded-lg">
             <Image
              src={post?.main_image}
              alt={"Thumbnail"}
              loading="eager"
              fill
              sizes="100vw"
              className="object-cover"
            />
        </div>}
  
        <Container>
                <article className="mx-auto max-w-screen-md ">
                    <div className="prose mx-auto my-3 dark:prose-invert prose-a:text-blue-600">
                        <div dangerouslySetInnerHTML={{ __html: post?.content }} />
                    </div>

                    {/* Sign Up Banner - Wave Design */}
                    <div className="my-12 rounded-2xl overflow-hidden shadow-xl">
                      <div className="relative">
                        {/* Main background */}
                        <div className="absolute inset-0 bg-greenBg"></div>
                        
                        {/* Geometric pattern */}
                        <div className="absolute inset-0 overflow-hidden">
                          <div className="w-full h-full opacity-8" 
                            style={{ 
                              backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='56' height='100' viewBox='0 0 56 100'%3E%3Cpath d='M28 66L0 50L0 16L28 0L56 16L56 50L28 66L28 100' fill='none' stroke='%23BDF864' stroke-opacity='0.08' stroke-width='1'/%3E%3C/svg%3E")`,
                              backgroundSize: '56px 100px'
                            }}
                          ></div>
                        </div>
                        
                        {/* Gradient vignette */}
                        <div className="absolute inset-0" style={{
                          background: 'radial-gradient(circle at center, transparent 0%, rgba(0, 46, 37, 0.6) 100%)'
                        }}></div>
                        
                        {/* Light beam */}
                        <div className="absolute bottom-0 left-1/4 w-1/2 h-40 bg-buttonsGreen/5 blur-3xl transform -translate-y-10"></div>
                        
                        {/* Single subtle accent line */}
                        <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-buttonsGreen/20 to-transparent"></div>
                        
                        {/* Floating elements - minimal */}
                        <div className="absolute inset-0 overflow-hidden">
                          <div className="absolute top-10 left-[30%] w-1.5 h-1.5 bg-buttonsGreen/30 rounded-full animate-float"></div>
                          <div className="absolute bottom-12 right-[35%] w-1.5 h-1.5 bg-white/20 rounded-full animate-float-slow"></div>
                        </div>
                        
                        {/* Content container */}
                        <div className="relative z-10 px-6 py-12 md:px-10 md:py-16">
                          <div className="max-w-5xl mx-auto">
                            <div className="flex flex-col md:flex-row gap-10 items-center">
                              {/* Badge and headline */}
                              <div className="md:w-3/5 text-center md:text-left">
                                <span className="inline-block px-4 py-1.5 bg-buttonsGreen/20 rounded-full text-buttonsGreen text-xs font-semibold tracking-wider uppercase mb-6">
                                  Try It Free For 7 Days
                                </span>
                                
                                <h3 className="text-2xl md:text-4xl font-bold text-white mb-6 leading-tight">
                                  Ready to dominate search rankings?
                                </h3>
                                
                                <p className="text-white/80 text-lg mb-6">
                                  Join thousands of businesses using SERPtag to climb their search rankings and drive more organic traffic.
                                </p>
                              </div>
                              
                              {/* CTA Card */}
                              <div className="md:w-2/5">
                                <div className="bg-white rounded-xl p-6 shadow-xl transform rotate-1 hover:rotate-0 transition-transform duration-300">
                                  <div className="text-center mb-6">
                                    <h4 className="text-greenBg font-bold text-xl mb-2">Start Your Free Trial</h4>
                                    <p className="text-gray-600 text-sm">Join thousands of satisfied businesses</p>
                                  </div>
                                  
                                  <Link 
                                    href="/sign-up" 
                                    className="block w-full bg-greenBg text-white font-bold px-6 py-3 rounded-lg text-center hover:bg-greenBg/90 transition-all duration-300 hover:shadow-lg"
                                  >
                                    Start Free Trial
                                  </Link>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="mb-7 mt-7 flex justify-between items-center">
                        {previousPost && (
                            <Link
                                href={`/blogs/${previousPost}`}
                                className="bg-brand-secondary/20 rounded-full px-5 py-2 text-sm text-blue-600 dark:text-blue-500 ">
                                ← Previous
                            </Link>
                        )}
                        <Link
                            href="/blogs"
                            className="bg-brand-secondary/20 rounded-full px-5 py-2 text-sm text-blue-600 dark:text-blue-500 ">
                            View all posts
                        </Link>
                        {nextPost && (
                            <Link
                                href={`/blogs/${nextPost}`}
                                className="bg-brand-secondary/20 rounded-full px-5 py-2 text-sm text-blue-600 dark:text-blue-500 ">
                                Next →
                            </Link>
                        )}
                    </div>
                </article>
            </Container>
      </>
    );
  }